var map = {
	"./EditFilled.svg": 257,
	"./altris.svg": 4344,
	"./altris_card_logo.svg": 3093,
	"./avatar.svg": 1538,
	"./close.svg": 7359,
	"./collaboratingCollegues/essential_01.svg": 6062,
	"./collaboratingCollegues/essential_02.svg": 8157,
	"./collaboratingCollegues/essential_03.svg": 9612,
	"./counsellingPatients/educate_01.png.svg": 9161,
	"./counsellingPatients/educate_02.png.svg": 6106,
	"./counsellingPatients/educate_03.png.svg": 7467,
	"./counsellingPatients/whole_patient_overlay.svg": 5127,
	"./currentChallenge/realize_01.svg": 2346,
	"./currentChallenge/visionLoss_01.png": 4317,
	"./currentChallenge/visionLoss_02.png": 6902,
	"./darkInfoRed.svg": 9902,
	"./deepeye.svg": 6634,
	"./deepeye_card_logo.svg": 9867,
	"./download.svg": 8281,
	"./download_blue.svg": 1136,
	"./file-pdf.svg": 9798,
	"./gradiant.svg": 4637,
	"./gradient_mobile.svg": 6026,
	"./hamburger.svg": 2962,
	"./homeFooterVisionImage.svg": 4608,
	"./identifyingGA/degenerative_01.png": 2125,
	"./identifyingGA/degenerative_02.png": 886,
	"./identifyingGA/focality_01.png.svg": 8892,
	"./identifyingGA/focality_02.png.svg": 6223,
	"./identifyingGA/hallmark.png.svg": 4031,
	"./identifyingGA/irreversible.png.svg": 993,
	"./identifyingGA/lesion_01.png": 2146,
	"./identifyingGA/lesion_02.png": 7289,
	"./identifyingGA/lesion_03.png": 6112,
	"./identifyingGA/lesion_size_01.png.svg": 3817,
	"./identifyingGA/lesion_size_02.png.svg": 762,
	"./identifyingGA/location_01.svg": 2591,
	"./identifyingGA/location_02.png.svg": 7827,
	"./imaging/flurosence_01.png": 7302,
	"./imaging/flurosence_02.png": 9069,
	"./imaging/fundus_01.png": 8013,
	"./imaging/fundus_02.png": 6774,
	"./imaging/optical_01.png": 280,
	"./imaging/optical_02.png": 5891,
	"./impactOnPatients/contrast_icon.svg": 7329,
	"./impactOnPatients/impact_on_patients.png": 9034,
	"./impactOnPatients/low_light_icon.svg": 9424,
	"./info.svg": 8697,
	"./infoIcon.svg": 6342,
	"./onboard_bg.svg": 6544,
	"./resources/caring_for_someone_with_ga.svg": 5442,
	"./resources/ga_by_numbers.png": 5474,
	"./resources/living_with_ga.svg": 5270,
	"./retinai.svg": 8609,
	"./retinai_card_logo.svg": 1200,
	"./roundBackIcon.svg": 3493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2267;